import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { SkeletonLoader } from 'shared/components/loading';

import useCart from 'src/hooks/use-cart';
import { DiscountBadgeType } from './use-discount-badge-text';

type DiscountBadgeProps = {
  badgeText: string | null;
  type: DiscountBadgeType;
};

export const DiscountBadge = ({ badgeText, type }: DiscountBadgeProps): JSX.Element | null => {
  const { isCalculating } = useCart();
  const hasBadgeBeenShown = useRef(false);

  useEffect(() => {
    if (badgeText) {
      hasBadgeBeenShown.current = true;
    }
  }, [badgeText]);

  if (isCalculating && hasBadgeBeenShown.current) {
    return (
      <StyledSkeletonLoader data-testid='skeleton-loader' height={16} width={64} isLeftAligned useExactDimensions />
    );
  }

  if (!badgeText) {
    return null;
  }

  return (
    <Wrapper data-testid='discount-badge' $type={type}>
      {badgeText}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: ${({ $type, theme }) =>
    $type === 'sale' ? theme.customized.colors.discountTag : theme.colors.green[40]};
  border-radius: ${({ theme }) => theme.customized.radius.tags};
  color: #fff;
  display: block;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 4px;
  padding: 2px 6px;
  width: fit-content;
`;

const StyledSkeletonLoader = styled(SkeletonLoader)`
  margin-bottom: 4px;
`;
